<template>
  <div class="form-container" id="login-form">
    <form @submit.prevent="loginUserMounted" method="POST">
      <div class="social-login">
        <router-link to="/">
          <img src="@/assets/logo.png" id="form-logo" alt="Dating4Pets logo" />
        </router-link>
      </div>
      <h1 class="form-header">Welcome back!</h1>
      <!-- <div class="input-field">
        <fa class="icon" icon="user" />
        <input type="text" placeholder="Username" v-model="formData.username" />
      </div> -->
      <div class="input-field">
        <fa class="icon" icon="at" />
        <input
          required
          type="email"
          placeholder="Email"
          v-model="formData.email"
        />
      </div>
      <div class="input-field">
        <fa class="icon" icon="key" />
        <input
          required
          type="password"
          placeholder="Password"
          v-model="formData.password"
          id="login-pass"
        />
        <div
          class="show-pass"
          @click="showPass('login-pass')"
          id="show-login-pass"
        >
          <fa class="icon" icon="eye" />
        </div>
      </div>
      <Button text="Log In" type="submit" />

      <Link
        text="Register instead"
        icon="sync-alt"
        @click="toggleForm"
        color="#454545"
      />
      <!-- <p>
        You don't have an account?
        <a href="#" v-on:click="toggleForm" class="form-link">Register now</a>.
      </p> -->

      <p>
        Forgot your password?
        <a href="#" @click="resetPassword" class="form-link">Reset Password</a>.
      </p>

      <div class="social-login">
        <h3>Or</h3>
        <SocialLogin
          icon="google"
          @click="loginGoogle"
          text="Continue with Google"
        />
        <SocialLogin
          icon="facebook"
          @click="loginFacebook"
          text="Continue with Facebook"
        />
      </div>
    </form>
  </div>
  <div class="form-container" id="register-form" style="display: none">
    <form @submit.prevent="registerUserMounted" method="POST">
      <div class="social-login">
        <router-link to="/">
          <img src="@/assets/logo.png" id="form-logo" alt="Dating4Pets logo" />
        </router-link>
      </div>
      <h1 class="form-header">Welcome!</h1>
      <div class="input-field">
        <fa class="icon" icon="user" />
        <input
          required
          type="text"
          placeholder="First Name"
          v-model="formData.firstName"
        />
      </div>
      <div class="input-field">
        <fa class="icon" icon="user" />
        <input
          required
          type="text"
          placeholder="Last Name"
          v-model="formData.lastName"
        />
      </div>
      <!-- <div class="input-field">
        <fa class="icon" icon="user" />
        <input type="text" placeholder="Username" v-model="formData.username" />
      </div> -->
      <div class="input-field">
        <fa class="icon" icon="at" />
        <input
          required
          type="email"
          placeholder="Email"
          v-model="formData.email"
        />
      </div>
      <div class="input-field">
        <fa class="icon" icon="birthday-cake" />
        <input
          required
          type="date"
          placeholder="Date of birth"
          v-model="formData.birthday"
        />
      </div>
      <div class="input-field">
        <fa class="icon" icon="key" />
        <input
          required
          type="password"
          placeholder="Password"
          v-model="formData.password"
          id="register-pass"
        />
        <div
          class="show-pass"
          @click="showPass('register-pass')"
          id="show-register-pass"
        >
          <fa class="icon" icon="eye" />
        </div>
      </div>
      <div class="input-field">
        <fa class="icon" icon="key" />
        <input
          required
          type="password"
          placeholder="Repeat Password"
          v-model="formData.repeatPassword"
          id="repeat-pass"
        />
        <div
          class="show-pass"
          @click="showPass('repeat-pass')"
          id="show-repeat-pass"
        >
          <fa class="icon" icon="eye" />
        </div>
      </div>
      <Button text="Sign Up" type="submit" />
      <!-- <p>
        You already have an account?
        <a href="#" v-on:click="toggleForm" class="form-link">Log in</a>.
      </p> -->
      <Link
        text="Log In instead"
        icon="sync-alt"
        @click="toggleForm"
        color="#454545"
        type="text"
      />
      <div class="social-login">
        <h3>Or</h3>
        <SocialLogin
          icon="google"
          @click="loginGoogle"
          text="Continue with Google"
        />
        <SocialLogin
          icon="facebook"
          @click="loginFacebook"
          text="Continue with Facebook"
        />
      </div>
    </form>
  </div>
</template>
<script>
import Button from "./Button.vue";
import Link from "./Link.vue";
import SocialLogin from "./SocialLogin.vue";
import axios from "axios";
import Swal from "sweetalert2";

let formToggler = false;

Date.prototype.toDateInputValue = function () {
  let local = new Date(this);
  local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
  return local.toJSON().slice(0, 10);
};

function loginUser(formData, router, redirect) {
  formData.formType = "login";

  // CHECK FOR THE LENGTH OF THE PASSWORD. IF LESS THAN 6, IT'S A WRONG PASSWORD
  if (formData.password.length < 6) {
    Swal.fire({
      title: "Wrong Password!",
      text: "The password you provided does not match with your credentials!",
      icon: "warning",
      confirmButtonText: "Try again",
      confirmButtonColor: "#edc541",
    });
    return;
  }

  axios
    .post(`${process.env.VUE_APP_BACKEND}/users/login`, formData)
    .then(function (res) {
      let jwt = res.data;
      localStorage.setItem("jwt", jwt);
      router.push(redirect);
    })
    .catch(function (error) {
      if (error.response) {
        Swal.fire({
          title: "Error",
          text:
            "An error occured when you tried to log in. Error: " +
            error.response.data.message,
          icon: "error",
          confirmButtonText: "Try again",
          confirmButtonColor: "#edc541",
        });
      }
    });
}

function registerUser(formData, router, redirect) {
  formData.formType = "resgister";

  // CHECK IF THE PASSWORD IS MORE THAN 6 CHARACTERS
  if (formData.password.length < 6) {
    Swal.fire({
      title: "Your password must be 6 characters or more!",
      text: "We recommend using a strong password, as it can save you from a lot of trouble in the future!",
      icon: "warning",
      confirmButtonText: "Try again",
      confirmButtonColor: "#edc541",
    });
    return;
  }

  // CHECK IF THE PASSWORDS MATCH
  if (formData.password != formData.repeatPassword) {
    Swal.fire({
      title: "Your passwords do not match!",
      text: 'The fields "Password" and "Repeat Password" have different values!',
      icon: "warning",
      confirmButtonText: "Try again",
      confirmButtonColor: "#edc541",
    });
    return;
  }

  let birthday = new Date(formData.birthday);
  let today = new Date();

  let age = today.getFullYear() - birthday.getFullYear();
  let m = today.getMonth() - birthday.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
    age--;
  }

  formData.age = age;
  axios
    .post(`${process.env.VUE_APP_BACKEND}/users/register`, formData)
    .then(function () {
      loginUser(formData, router, redirect);
    })
    .catch(function (error) {
      if (error.response) {
        Swal.fire({
          title: "Error",
          text:
            "An error occured when you tried to log in. Error: " +
            error.response.data.message,
          icon: "error",
          confirmButtonText: "Try again",
          confirmButtonColor: "#edc541",
        });
      }
    });
}

function sanetizeData(self) {
  self.formData = {
    username: "",
    firstName: "",
    lastName: "",
    birthday: "",
    age: "",
    email: "",
    password: "",
    repeatPassword: "",
    formType: "",
    userToken: "",
    profileImage: "string",
  };
}

export default {
  name: "Form",
  components: {
    Button,
    Link,
    SocialLogin,
  },
  methods: {
    toggleForm(type) {
      formToggler = !formToggler;
      let loginFormElement = document.querySelector("#login-form");
      let registerFormElement = document.querySelector("#register-form");

      if (!formToggler && type !== "signup") {
        // we need to change from register form to log in form
        document.title = `Login ${this.title}`;
        loginFormElement.style = "display: flex;";
        registerFormElement.style = "display: none;";
      } else {
        // we need to change from log in form to register form
        document.title = `Register ${this.title}`;
        loginFormElement.style = "display: none;";
        registerFormElement.style = "display: flex;";
      }
    },
    loginUserMounted() {
      let self = this;
      loginUser(this.formData, self.$router, this.redirect);
    },
    registerUserMounted() {
      let self = this;
      registerUser(this.formData, self.$router, this.redirect);
    },
    showPass(id) {
      let inputField = document.querySelector("#" + id);
      if (inputField.getAttribute("type")) {
        inputField.setAttribute("type", "");
      } else {
        inputField.setAttribute("type", "password");
      }
    },
    resetPassword() {
      if (this.formData.email == "") {
        Swal.fire(
          "An error occured.",
          "You need to provide an email address.",
          "error"
        );
      } else {
        axios
          .get(
            `${process.env.VUE_APP_BACKEND}/users/forget/` + this.formData.email
          )
          .then(() => {
            Swal.fire(
              "Success",
              "An email has been sent to your address <br><b>" +
                this.formData.email +
                "</b>",
              "success"
            );
          })
          .catch((err) => {
            Swal.fire("An error occured.", err, "error");
          });
      }
    },
    loginGoogle() {
      location.replace(`${process.env.VUE_APP_BACKEND}/google/auth`);
      sanetizeData(this);
    },
    loginFacebook() {
      location.replace(`${process.env.VUE_APP_BACKEND}/facebook/auth`);
      sanetizeData(this);
    },
  },
  mounted() {
    // let documentTitle = this.title + " - Dating4Pets";

    const query = window.location.search;
    const getParameters = new URLSearchParams(query);

    // if (getParameters.has("signup")) {
    if (getParameters.get("signup") === "true") {
      this.toggleForm("signup");
    } else {
      document.title = `Login ${this.title}`;
    }
    if (getParameters.get("redirect")) {
      this.redirect =
        getParameters.get("redirect") +
        "&response=" +
        getParameters.get("response");
    }
    // }
  },
  data() {
    return {
      formData: {
        username: "",
        firstName: "",
        lastName: "",
        birthday: new Date().toDateInputValue(),
        // .toLocaleDateString("el")
        // .split("/")
        // .reverse()
        // .join("-")
        age: "",
        email: "",
        password: "",
        repeatPassword: "",
        formType: "",
        userToken: "",
        profileImage: "string",
      },
      redirect: "/",
      title: "- Dating4Pets",
    };
  },
};
</script>

<style scoped>
.form-container {
  display: flex;

  /* FOR TESTING  */
  /* display: none; */

  justify-content: center;
  align-items: center;
  overflow: initial;
  color: var(--dark-clr);

  min-width: 18rem;
  width: 20%;
  max-width: 35rem;
  margin: 1rem;
  /* margin-inline-start: auto; */
  /* margin: auto; */
  /* margin-block-start: 7em; */
}

form {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;
  /* background: white;
  border-radius: 1rem; */
  padding-block: 2em;
  padding-inline: 1.5em;
  /* box-shadow: 0 0.1rem 1rem 0.2rem rgba(126, 126, 126, 0.3); */
  gap: var(--gap);
  z-index: 100;
  width: 100%;
}

#form-logo {
  width: 50%;
  aspect-ratio: 1;
}

p {
  color: black;
}
a {
  text-decoration: none;
}
.form-link {
  color: var(--primary-clr);
  transition: 0.5s ease;
}
.form-link:hover,
.form-link:focus {
  color: var(--dark-clr);
}

.input-field {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: visible;
  width: 100%;
  position: relative;
}

.input-field > input {
  height: 2rem;
  width: inherit;
  background: white;
  color: var(--dark-clr);
  border-radius: 2rem;
  padding: 0.2rem 1rem;
  margin: 0.2rem;
  /* margin-inline-start: auto; */
  border: none;
  box-shadow: var(--box-shadow);
  font-weight: bold;
  transition: 0.5s ease;
}

.input-field > input::placeholder {
  color: var(--mid-dark-clr);
}

.input-field > input:focus {
  border: none;
  box-shadow: var(--box-shadow-focus);
}

.input-field > .icon,
.show-pass > .icon {
  /* color: var(--icon-color); */
  color: var(--primary-clr);
  margin: 0 0.5rem;
}

.show-pass {
  position: absolute;
  right: calc(0% + 1em);
  cursor: pointer;
}

.show-pass:hover > .icon {
  color: var(--mid-dark-clr);
}

@media screen and (max-width: 30rem) {
  .form-container {
    margin: 1rem;
  }
}

.social-login {
  overflow: visible;
  display: none;
  flex-direction: column;
  gap: var(--gap);
}

@media screen and (max-width: 40rem) {
  .social-login {
    display: flex;
  }
}
</style>
